<template>
  <v-layout>
    <v-row align="center" justify="center">
      
    </v-row>
  </v-layout>
</template>

<script>
export default {
    name: 'Certificates',
    data () {
        return {
            certs: []
        }
    },
    async created () {
        const data = await fetch('/certificates.json').then(resp => resp.json())
        this.certs = data.certs
    }
}
</script>